/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FlagAIcon16Light } from './FlagAIcon16Light';
import { FlagAIcon16Regular } from './FlagAIcon16Regular';
import { FlagAIcon16Solid } from './FlagAIcon16Solid';
import { FlagAIcon20Light } from './FlagAIcon20Light';
import { FlagAIcon20Regular } from './FlagAIcon20Regular';
import { FlagAIcon20Solid } from './FlagAIcon20Solid';
import { FlagAIcon24Regular } from './FlagAIcon24Regular';
import { FlagAIcon24Solid } from './FlagAIcon24Solid';
import { FlagAIcon32Regular } from './FlagAIcon32Regular';
import { FlagAIcon64Regular } from './FlagAIcon64Regular';
var sizes = {
    16: {
        light: FlagAIcon16Light,
        regular: FlagAIcon16Regular,
        solid: FlagAIcon16Solid,
    },
    20: {
        light: FlagAIcon20Light,
        regular: FlagAIcon20Regular,
        solid: FlagAIcon20Solid,
    },
    24: {
        regular: FlagAIcon24Regular,
        solid: FlagAIcon24Solid,
    },
    32: {
        regular: FlagAIcon32Regular,
    },
    64: {
        regular: FlagAIcon64Regular,
    },
};
export var FlagAIcon = forwardRef('FlagAIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
